import React, {useMemo} from 'react'
import styles from './UIGameTradeCreatorProposal.module.scss'
import {Avatar} from '../../../common/Avatar'
import {CardEnum} from '@colonist/game-states'
import IconTradeArrowRed from '@static/images/icon_trade_arrow_red.svg'
import {cardEnumsToCardState} from '../../../utils/cards'
import {UIGameCardInventory} from '../../../common/UIGameCardInventory/UIGameCardInventory'
import {UIGameCard} from '../../../common/UIGameCard'
// eslint-disable-next-line no-restricted-imports
import {UIImagePathController} from '../../../../../../code/client/shared/scripts/UIEnums'
import {TradeErrorHighlightLocationEnum} from '@colonist/game-mechanic-validators'
import {useGameStore} from '../../../store/GameStoreContext'
import {usePlayerValidators} from '../../../store/selectors/usePlayerValidators'
import {useCardsToHighlight} from '../useCardsToHighlight'

export const UIGameTradeCreatorProposalOfferedHalf = ({
    offeredCards,
    onClickOfferedCard,
    isPortraitLayout,
}: {
    offeredCards: CardEnum[]
    onClickOfferedCard: (card: CardEnum) => void
    isPortraitLayout?: boolean | undefined
}) => {
    const gameState = useGameStore((state) => state.gameState)
    const myColor = useGameStore((state) => state.myColor)
    const counterOffer = useGameStore((state) => state.gameTrade.counterOffer)
    const isBankTradeMode = useGameStore((state) => state.gameTrade.isBankTradeMode)
    const {getPlayerValidator} = usePlayerValidators()

    const isCreatingCounterOffer = counterOffer != null
    const myPlayerValidator = getPlayerValidator(myColor)
    const offeredCardsState = useMemo(() => cardEnumsToCardState(offeredCards), [offeredCards])
    const merchantState = gameState.mechanicMerchantState
    const amIMerchantOwner = merchantState?.owner === myColor
    const shouldShowBankTradeRatio = isBankTradeMode
    const myBankTradeRatioState = myPlayerValidator.bankTradeRatiosState
    const cardsToHighlight = useCardsToHighlight(TradeErrorHighlightLocationEnum.ProposalOffered)

    const shouldShowMerchant = !isCreatingCounterOffer && amIMerchantOwner && merchantState.activeTradeBonus != null
    return (
        <div className={styles.proposalOfferedHalfContainer}>
            <div className={styles.leftContainer}>
                <Avatar
                    image={myPlayerValidator.displayIcon}
                    color={myColor}
                    profilePictureUrl={myPlayerValidator.profilePictureUrl}
                    className={styles.avatar}
                />
                <img src={IconTradeArrowRed} className={styles.givingArrow}/>
                <div className={styles.cardStackContainer}>
                    <UIGameCardInventory
                        showTipTitle={false}
                        showTipBody={false}
                        cardState={offeredCardsState}
                        onClickCard={onClickOfferedCard}
                        animate
                        enablePartition
                        className={styles.cardStack}
                        cardSize={isPortraitLayout ? 'sm' : 'base'}
                        cardsToHighlight={cardsToHighlight}
                        bankTradeRatiosState={shouldShowBankTradeRatio ? myBankTradeRatioState : undefined}/>
                </div>
            </div>

            <div className={styles.rightContainer}>
                {shouldShowMerchant && merchantState.activeTradeBonus != null && (
                    <div className={styles.merchantWrapper}>
                        <UIGameCard
                            cardEnum={merchantState.activeTradeBonus}
                            className={styles.card}
                            size={isPortraitLayout ? 'sm' : 'base'}/>
                        <img className={styles.merchantIcon} src={UIImagePathController.merchantByColor[myColor]}/>
                    </div>
                )}
            </div>
        </div>
    )
}
